// Marketing homepage palette — warm, light, built to carry the flat-vector
// illustrations. This is deliberately NOT the product palette: /flowstate stays
// dark via src/components/Flowstate/context/ThemeContext.jsx. A bright landing
// page and a dark focused workspace do different jobs.
export const palette = {
  // Surfaces
  bg: "#fbfaf8", // warm paper
  bgAlt: "#f4f1ec", // banded sections
  paper: "#ffffff",
  paperRaised: "#ffffff",

  // Ink
  text: "#16181d",
  textMuted: "#55595f",
  textFaint: "#8b8f96",

  // Brand accent (shared with the product so the two feel related)
  primary: "#3b82f6",
  primaryHover: "#2563eb",
  primarySoft: "rgba(59, 130, 246, 0.10)",
  primaryBorder: "rgba(59, 130, 246, 0.28)",

  // Lines
  border: "rgba(22, 24, 29, 0.10)",
  borderStrong: "rgba(22, 24, 29, 0.20)",

  // Shadows — soft and low, so cards sit on the paper rather than float
  shadowSm: "0 1px 2px rgba(22, 24, 29, 0.04)",
  shadowMd: "0 2px 8px rgba(22, 24, 29, 0.06), 0 1px 2px rgba(22, 24, 29, 0.04)",
  shadowLg: "0 12px 32px -8px rgba(22, 24, 29, 0.12)",

  ctaGradient: "linear-gradient(90deg, #3b82f6 0%, #2563eb 100%)",

  // Illustration palette. Kept here so every illustration draws from one set
  // and they read as a single hand.
  ill: {
    sky: "#cfe6f7",
    skyDeep: "#a8d0ee",
    leaf: "#7fb069",
    leafDeep: "#5d8f4c",
    sun: "#f2b544",
    sunSoft: "#f7d089",
    clay: "#e2705c",
    claySoft: "#efa393",
    plum: "#8b5cf6",
    river: "#3b82f6",
    riverDeep: "#2563eb",
    sand: "#efe4d2",
    wood: "#d9b98f",
    woodDeep: "#bd9a6f",
    ink: "#2c3038",
    // Skin tones, so the figures aren't all one default
    skin: ["#f0c9a4", "#c98d63", "#8d5a3b", "#e8b48c"],
  },
};

export default palette;
